import React from 'react';

import { useTheme, trackingId, useResponsiveCtx } from '@blueprint/ui';

import Text from './Text';

const defaultStyles = {
  fontSize: 12,
  lineHeights: 'normal',
  fontWeights: 'normal',
  letterSpacing: 'normal',
};

const defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p',
};

/**
 * Typography
 */
const Typography = React.forwardRef(({ variant, ...rest }, ref) => {
  const { as = defaultVariantMapping[variant] } = useTheme(
    `typography.headings.typeMapping.${variant}`,
    defaultStyles,
  );
  const { hMedia } = useResponsiveCtx();

  return (
    <Text
      data-testid="Typography"
      data-trackid={trackingId('Typography')}
      as={as}
      variant={variant}
      {...rest}
      ref={ref}
      hMedia={hMedia}
    />
  );
});

Typography.displayName = 'Typography';

export default Typography;
